"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddTag = void 0;

var tslib_1 = require("tslib");

var ui_button_1 = require("@hopin-team/ui-button");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_menu_1 = require("@hopin-team/ui-menu");

var ui_text_1 = require("@hopin-team/ui-text");

var ui_text_field_1 = require("@hopin-team/ui-text-field");

var use_id_1 = require("@hopin-team/use-id");

var react_1 = tslib_1.__importStar(require("react"));

var root_1 = require("./styled/root");

var AddTag = function AddTag(_a) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      ariaLabel = _a["aria-label"],
      testID = _a["data-testid"],
      id = _a.id,
      label = _a.label,
      hideLabel = _a.hideLabel,
      name = _a.name,
      _b = _a.sizeOption,
      sizeOption = _b === void 0 ? 'medium' : _b,
      _c = _a.addText,
      addText = _c === void 0 ? 'Add' : _c,
      canCreateNew = _a.canCreateNew,
      _d = _a.clearText,
      clearText = _d === void 0 ? 'Clear query' : _d,
      onAddTag = _a.onAddTag,
      onSelectTag = _a.onSelectTag,
      tags = _a.tags,
      selectedTags = _a.selectedTags,
      _e = _a.noResultsText,
      noResultsText = _e === void 0 ? 'No Results Found' : _e,
      _f = _a.newTagText,
      newTagText = _f === void 0 ? 'New' : _f,
      isInline = _a.isInline,
      visibleOptionsCount = _a.visibleOptionsCount,
      rest = tslib_1.__rest(_a, ["className", "__UIScope", 'aria-label', 'data-testid', "id", "label", "hideLabel", "name", "sizeOption", "addText", "canCreateNew", "clearText", "onAddTag", "onSelectTag", "tags", "selectedTags", "noResultsText", "newTagText", "isInline", "visibleOptionsCount"]);

  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'AddTag',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  var fieldId = (0, use_id_1.useId)(id);

  var _g = tslib_1.__read((0, react_1.useState)(false), 2),
      isShowing = _g[0],
      setIsShowing = _g[1];

  var _h = tslib_1.__read((0, react_1.useState)([]), 2),
      suggestions = _h[0],
      setSuggestions = _h[1];

  var _j = tslib_1.__read((0, react_1.useState)(false), 2),
      hasNoResults = _j[0],
      setHasNoResults = _j[1];

  var _k = tslib_1.__read((0, react_1.useState)(''), 2),
      newTag = _k[0],
      setNewTag = _k[1];

  var inputRef = (0, react_1.useRef)(null);
  var tagOptions = tags === null || tags === void 0 ? void 0 : tags.filter(function (tag) {
    return !(selectedTags === null || selectedTags === void 0 ? void 0 : selectedTags.includes(tag));
  });
  var canRenderAllTags = !suggestions.length && !hasNoResults && !newTag;
  var canRenderSeparator = canRenderAllTags && tagOptions && tagOptions.length > 0 && selectedTags && selectedTags.length > 0;

  var handleInputFocus = function handleInputFocus() {
    if ((tags === null || tags === void 0 ? void 0 : tags.length) || (selectedTags === null || selectedTags === void 0 ? void 0 : selectedTags.length) || suggestions.length || hasNoResults || newTag) {
      setIsShowing(true);
    }
  };

  var validVisibleOptions = visibleOptionsCount && tags && tags.length > visibleOptionsCount && canRenderAllTags ? visibleOptionsCount : undefined; // Enter key and Add button click handler

  var handleAdd = function handleAdd() {
    var _a;

    var value = (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.value;
    var tagExists = (tags === null || tags === void 0 ? void 0 : tags.some(function (tag) {
      return tag.toLowerCase() === (value === null || value === void 0 ? void 0 : value.toLowerCase());
    })) || suggestions.length > 0;

    if (inputRef && inputRef.current && value) {
      // Can create new tags and the input value does not already exist - create value as new tag
      if (canCreateNew && !tagExists) {
        onAddTag(value);
      } // Cannot create new tags and the input does not already exist - show no results found
      else if (!canCreateNew && !tagExists) {
          setHasNoResults(true);
        } // Otherwise - add the existing tag
        else {
            var existingTag = (tags === null || tags === void 0 ? void 0 : tags.find(function (tag) {
              return tag.toLowerCase() === (value === null || value === void 0 ? void 0 : value.toLowerCase());
            })) || suggestions[0];
            existingTag && onAddTag(existingTag);
          } // Clear the input field and reset hasNoResults state


      inputRef.current.value = '';
      setHasNoResults(false);
      setSuggestions([]);
      setNewTag('');
      setIsShowing(true);
    }
  }; // Input change handler to render suggestions from tags not already selected


  var handleInputChange = function handleInputChange(e) {
    var value = e.target.value;
    var matches = [];
    var regex = new RegExp("".concat(value), 'gi');

    if (tags && value.length > 0) {
      matches = tags.filter(function (tag) {
        return tag.match(regex);
      });
    } // If there are no matches and the input field is not blank


    if (!matches.length && value.length > 0) {
      // Display no results text if not allowed to create new tags
      if (!canCreateNew) {
        setHasNoResults(true);
      } // Display new tag option if allowed to create new tags
      else if (canCreateNew) {
          setNewTag(value);
        }
    } // If there is a match or no text in the input field, reset hasNoResults and newTag states
    else if (matches.length > 0 || value.length === 0) {
        setHasNoResults(false);
        setNewTag('');
      } // Set suggestions from only unselected tags


    setSuggestions(matches.filter(function (match) {
      return !(selectedTags === null || selectedTags === void 0 ? void 0 : selectedTags.includes(match));
    }));
  };

  var handleClear = function handleClear() {
    setHasNoResults(false);
    setSuggestions([]);
    setNewTag('');
  };

  var a11yProps = {};

  if (label || isShowing) {
    a11yProps.id = fieldId;
  } else {
    a11yProps['aria-label'] = ariaLabel;
  }

  return react_1.default.createElement(root_1.Root, {
    className: rootClasses,
    "data-testid": testID,
    isInline: isInline
  }, react_1.default.createElement(ui_menu_1.Menu, {
    isShowing: isShowing,
    onClose: function onClose() {
      return setIsShowing(false);
    },
    isDismissible: true
  }, react_1.default.createElement(ui_text_field_1.TextField, tslib_1.__assign({
    ref: inputRef,
    label: label,
    hideLabel: hideLabel,
    name: name,
    size: sizeOption,
    onChange: handleInputChange,
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' && handleAdd();
    },
    onFocus: handleInputFocus,
    clearText: clearText,
    onClear: handleClear,
    button: react_1.default.createElement(ui_button_1.Button, {
      type: "button",
      isInline: true,
      // 'small' input pairs with 'tiny' button, and 'medium' with 'small'
      size: sizeOption === 'small' ? 'tiny' : 'small',
      onClick: handleAdd,
      disabled: hasNoResults
    }, addText)
  }, a11yProps, rest)), react_1.default.createElement(ui_menu_1.MenuContent, {
    visibleOptionsCount: validVisibleOptions,
    p: 1
  }, react_1.default.createElement(ui_menu_1.MenuSelect, {
    labelledById: fieldId,
    currentIndex: (selectedTags === null || selectedTags === void 0 ? void 0 : selectedTags.length) || -1
  }, hasNoResults && react_1.default.createElement(ui_text_1.Text, {
    pattern: "emphasis",
    p: 1,
    element: "p"
  }, noResultsText), Boolean(newTag) && react_1.default.createElement(ui_menu_1.MenuSelectCheckbox, {
    label: newTag,
    onClick: function onClick() {
      return onSelectTag(newTag);
    },
    subtext: {
      label: newTagText,
      position: 'right'
    },
    selected: selectedTags === null || selectedTags === void 0 ? void 0 : selectedTags.includes(newTag),
    p: 1
  }), !hasNoResults && suggestions && suggestions.map(function (suggestion, i) {
    return react_1.default.createElement(ui_menu_1.MenuSelectCheckbox, {
      key: i,
      label: suggestion,
      onClick: function onClick() {
        return onSelectTag(suggestion);
      },
      selected: selectedTags === null || selectedTags === void 0 ? void 0 : selectedTags.includes(suggestion),
      p: 1
    });
  }), canRenderAllTags && selectedTags && selectedTags.map(function (selectedTag, i) {
    return react_1.default.createElement(ui_menu_1.MenuSelectCheckbox, {
      key: i,
      label: selectedTag,
      onClick: function onClick() {
        return onSelectTag(selectedTag);
      },
      selected: true,
      p: 1,
      my: 0.5
    });
  }), canRenderSeparator && react_1.default.createElement("hr", {
    style: {
      marginTop: '0.5rem',
      marginBottom: '0.5rem'
    }
  }), canRenderAllTags && tagOptions && tagOptions.map(function (tag, i) {
    return react_1.default.createElement(ui_menu_1.MenuSelectCheckbox, {
      key: i,
      label: tag,
      onClick: function onClick() {
        return onSelectTag(tag);
      },
      selected: selectedTags === null || selectedTags === void 0 ? void 0 : selectedTags.includes(tag),
      p: 1,
      my: 0.5
    });
  })))));
};

var AddTagWithSpace = (0, ui_helper_with_space_1.withSpace)(AddTag);
exports.AddTag = AddTagWithSpace;